export const MAX_WORK_SHIFT_DURATION_HOURS = 24

export const MATRICULE_PREFIX = 'AGD'

export const WORK_SHIFT_STEP_DURATION_MINUTES = 10

export const MINIMUM_BREAK_BETWEEN_SHIFTS_MINUTES = 20
export const MAX_WEEKLY_HOURS = 35
export const MAX_CONSECUTIVE_WORK_DAYS = 6
